import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  AddressControllerApiFactory,
  type SuccessGetDoorDeliveryAddressesAddressesInner,
  SuccessGetDoorDeliveryAddressesAddressesInnerTypeEnum,
} from '@redteclab/api/clients/bully'

import { isSensitiveLoginExpiredAxiosError, useGlooApi } from '../../api'
import { useGlobalConfigContext } from '../../global-config'

const getAddressApiSwrBillingAddressKey = (): string => {
  return 'AddressApiSwrBillingAddress'
}

export const useAddressApiSwrBillingAddressMutation = ({
  onSuccess,
}: {
  onSuccess: (
    arg: SuccessGetDoorDeliveryAddressesAddressesInner | undefined,
  ) => void
}): SWRMutationResponse => {
  const globalConfig = useGlobalConfigContext()
  const client = useGlooApi(AddressControllerApiFactory)

  return useSWRMutation(getAddressApiSwrBillingAddressKey(), async () => {
    let doorDeliveryAddresses:
      SuccessGetDoorDeliveryAddressesAddressesInner[] | null = null

    // eslint-disable-next-line unicorn/try-complexity -- don't reference, refactor if touched
    try {
      const response = await client.addressesV2TenantDoorDeliveryGet({
        tenant: globalConfig.tenantAndEnv,
      })

      doorDeliveryAddresses = response.data.addresses ?? []
    } catch (error) {
      if (isSensitiveLoginExpiredAxiosError(error)) {
        return undefined
      }

      throw error
    }

    const billingAddress = doorDeliveryAddresses.find(
      (it) =>
        it.type ===
        SuccessGetDoorDeliveryAddressesAddressesInnerTypeEnum.Billing,
    )

    try {
      onSuccess(billingAddress)
    } catch {
      // void
    }

    return billingAddress
  })
}
